import { motion } from 'framer-motion';

const phases = [
  { label: 'Experiments', note: 'AI as chat' },
  { label: 'Adoption', note: 'AI enters work' },
  { label: 'Governance gap', note: 'control lags' },
  { label: 'Operating layer', note: 'accountable AI' },
];

export function AdoptionTimeline() {
  return (
    <div className="relative w-full pt-2">
      <div className="absolute left-0 right-0 top-5 h-0.5 bg-cyan-500/15" />
      <motion.div
        className="absolute left-0 top-5 h-0.5 bg-gradient-to-r from-cyan-400 to-blue-500"
        initial={{ width: '0%' }}
        whileInView={{ width: '100%' }}
        viewport={{ once: true }}
        transition={{ duration: 1.6, ease: 'easeInOut' }}
      />
      <div className="relative flex justify-between">
        {phases.map((p, i) => (
          <motion.div
            key={p.label}
            className="flex w-1/4 flex-col items-center gap-2 text-center"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.35 * i + 0.2 }}
          >
            <motion.span
              className={`h-3.5 w-3.5 rounded-full ${i === phases.length - 1 ? 'bg-cyan-400' : 'bg-cyan-500/50'}`}
              animate={i === phases.length - 1 ? { scale: [1, 1.35, 1] } : {}}
              transition={{ duration: 2, repeat: Infinity }}
            />
            <span className="text-cyan-100/90">{p.label}</span>
            <span className="text-cyan-100/50">{p.note}</span>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
